const INITIAL_STATE = {
  errors: {},
  data: {}
}
  
const emailVerification = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'CHECK_EMAIL':
	  return { ...state, ...INITIAL_STATE, data: action.data }
  case 'CHECK_EMAIL_FAILED':
	  return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
	  return { ...state }
  }
};
  
export default emailVerification;
  